var html = $('html');

$(function () {
    darkMode();
    whiteLogo();
    carousel();
    video();
    gallery();
    author();
    offCanvas();
});

function darkMode() {
    $('.toggle-track').on('click', function () {
        if (html.hasClass('dark-mode')) {
            html.removeClass('dark-mode');
            localStorage.setItem('alto_dark', false);
        } else {
            html.addClass('dark-mode');
            localStorage.setItem('alto_dark', true);
        }
    });
}

function whiteLogo() {
    if (typeof gh_white_logo != 'undefined') {
        var whiteImage = '<img class="logo-image white" src="' + gh_white_logo + '">';
        $('.logo').append(whiteImage);
    }
}

function carousel() {
    var carousel = $('.carousel');
    var carouselCaseStudy = $('.carousel-case-study');
    var carouselJoinOurTeam = $('.carousel-join-our-team');
    var postImage = carousel.find('.post-image');
    var imageHeight, nav;

    function moveNav() {
        imageHeight = postImage.height();
        if (!nav) {
            nav = carousel.find('.owl-prev, .owl-next');
        }
        nav.css({
            top: imageHeight + 'px',
            opacity: 1,
        });
    }

    function activeHasChanged(event, className){
        $(className + ' .owl-stage .owl-item').removeClass('adjust-padding-left');
        $(className + ' .owl-stage .owl-item').removeClass('adjust-padding-right');
        setTimeout(function() {
            // Adiciona o seletor classe nos item da pagina ativa
            $(className + ' .owl-stage .active:first').addClass('adjust-padding-left');
            $(className + ' .owl-stage .active:last').addClass('adjust-padding-right');
        },0);
    }

    carousel.owlCarousel({
        dots: false,
        autoHeight: true,
        margin: 20,
        nav: true,
        navText: [
            '<i class="icon icon-chevron-left"></i>',
            '<i class="icon icon-chevron-right"></i>',
        ],
        responsive: {
            0: {
                items: 1,
            },
            700: {
            items: 2,
            },
            900: {
                items: 3,
            },
            1201: {
                items: 4,
            },
        },
        onInitialized: function (event) {
            moveNav();
            setTimeout(function(){ 
                setOwlStageHeight(event, '.our-service', 40, 30);
            }, 0);
        },
        onResized: function (event) {
            moveNav();
            setTimeout(function(){ 
                setOwlStageHeight(event, '.our-service', 40, 30);
            }, 0);
        },
        onTranslated: function (event) {
            setTimeout(function(){ 
                setOwlStageHeight(event, '.our-service', 40, 30);
            }, 0);
        },
    });

    function getCaseStudyBottomHeight(){
        if (screen.width <= 425) {
            return 30;
        }
        else if (screen.width <= 768) {
            return 35;
        }
        return 40;
    }

    function getCaseStudyContainerHeight(){
        if (screen.width <= 425) {
            return 40;
        }
        else if (screen.width <= 768) {
            return 50;
        }
        return 70;
    }

    carouselCaseStudy.owlCarousel({
        loop: true,
        // margin: 70,
        // autoplay: true,
        dots: true,
        // autoplayTimeout: 3500,
        // autoplayHoverPause: true,
        // nav: true,
        responsive: {
            0: {
                items: 1
            },
            540: {
                items: 2
            }
        },
        onInitialized: function (event) {
            
            activeHasChanged(event, '.carousel-case-study');
            setTimeout(function(){ 
                setOwlStageHeight(event, '.carousel-case-study', getCaseStudyBottomHeight(), getCaseStudyContainerHeight()); 
            }, 0);
        },
        onResized: function (event) {
            activeHasChanged(event, '.carousel-case-study');
            setTimeout(function(){ 
                setOwlStageHeight(event, '.carousel-case-study', getCaseStudyBottomHeight(), getCaseStudyContainerHeight()); 
            }, 0);
        },
        onTranslated: function (event) {
            activeHasChanged(event, '.carousel-case-study');
            setTimeout(function(){ 
                setOwlStageHeight(event, '.carousel-case-study', getCaseStudyBottomHeight(), getCaseStudyContainerHeight()); 
            }, 0);
        },
    });

    // carouselJoinOurTeam.owlCarousel({
    //     loop: true,
    //     margin: 20,
    //     // autoplay: true,
    //     // autoplayTimeout: 3500,
    //     // autoplayHoverPause: true,
    //     // nav: true,
    //     responsiveClass: true,
    //     responsive: {
    //         0: {
    //             items: 1
    //         },
    //         701: {
    //             items: 2
    //         }
    //     },
    // });

    function setOwlStageHeight(event, className, bottomHeight, containerHeight) {
        var _bottomHeight = !bottomHeight?0:bottomHeight;
        var _containerHeight = !containerHeight?0:containerHeight;
        var maxHeight = 0;
        var imgHeight = parseInt( $(className + ' .owl-item.active .post-media:first-child').height());
        console.log('_bottomHeight: ' + _bottomHeight);
        console.log('_containerHeight: ' + _containerHeight);
        console.log('imgHeight: ' + imgHeight);
        $(className + ' .owl-item.active .card-omg-body').each(function () { // LOOP THROUGH ACTIVE ITEMS
            var excerpHeight = parseInt ($(this).children('.text-excerpt').height());
            var headerHeight = parseInt ($(this).children('.post-header').outerHeight(true));
            console.log('excertp: ' + excerpHeight);
            console.log('header: ' + headerHeight);
            var thisHeight = excerpHeight + headerHeight;
            maxHeight=(maxHeight>=thisHeight?maxHeight:thisHeight);
        });
        /*maxHeight = maxHeight+40;*/
        $(className + ' .owl-item.active .card-omg-body').css('height', maxHeight + _bottomHeight +'px' );
        $(className + ' .owl-stage').css('height', maxHeight + imgHeight + _containerHeight + 'px');
        $(className + ' .owl-stage-outer').css('height', maxHeight + imgHeight + _containerHeight + 'px');
    }
}




function video() {
    'use strict';
    $('.post-content').fitVids();
}

function gallery() {
    var images = document.querySelectorAll('.kg-gallery-image img');
    images.forEach(function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });
}

function author() {
    $('.author-name').on('click', function () {
        $(this).next('.author-social').toggleClass('enabled');
    });
}

function offCanvas() {
    var burger = jQuery('.burger');
    var canvasClose = jQuery('.canvas-close');

    jQuery('.nav-list').slicknav({
        label: '',
        prependTo: '.mobile-menu',
    });

    burger.on('click', function () {
        html.toggleClass('canvas-opened');
        html.addClass('canvas-visible');
        dimmer('open', 'medium');
    });

    canvasClose.on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery('.dimmer').on('click', function () {
        if (html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });

    jQuery(document).keyup(function (e) {
        if (e.keyCode == 27 && html.hasClass('canvas-opened')) {
            html.removeClass('canvas-opened');
            dimmer('close', 'medium');
        }
    });
}

function dimmer(action, speed) {
    'use strict';

    var dimmer = jQuery('.dimmer');

    switch (action) {
        case 'open':
            dimmer.fadeIn(speed);
            break;
        case 'close':
            dimmer.fadeOut(speed);
            break;
    }
}
